import { bool, string, node, func, object } from "prop-types";
import { isMobile } from "react-device-detect";
import { ScrollButtonContainer, useEstimateEditorSettings, useTableOverflowChecker } from "@tools";
import { Grid, TableContainer as MuiTableContainer } from "@material-ui/core";
import useStyle from "./TableContainer.style";
import classnames from "classnames";

export const TableContainer = ({
  tableHeaderRef,
  tableContainerIdentifier,
  children,
  onResize: resizeHandler,
  onScroll: scrollHandler,
  className,
  useAltBackground,
  useExpandCell,
  checkByScrollWidth,
}) => {
  const { isPdfPrinterView } = useEstimateEditorSettings();
  
  const {
    ref,
    onScroll,
    containerWidth,
    scrollWidth,
    isTableContentOverflowing,
    isScrolled,
    isEndScrolled,
    scrollButtonProps,
  } = useTableOverflowChecker(
    tableHeaderRef,
    resizeHandler,
    scrollHandler,
    checkByScrollWidth,
  );
  
  const classes = useStyle({ containerWidth, scrollWidth });
  
  return (
    <Grid item container className="relative">
      {
        !isPdfPrinterView && isTableContentOverflowing && !isMobile &&
        <ScrollButtonContainer {...scrollButtonProps} />
      }
      <MuiTableContainer
        ref={ref}
        id={tableContainerIdentifier}
        onScroll={onScroll}
        className={classnames(
          "tableContainer",
          "overflow-y-hidden",
          classes.root,
          isTableContentOverflowing && isScrolled && classes.overflows,
          isTableContentOverflowing && isEndScrolled && classes.overflowsRight,
          useAltBackground && classes.altBackground,
          useExpandCell && classes.useExpandCell,
          className,
        )}
      >
        <Grid container direction="column">
          { children }
        </Grid>
      </MuiTableContainer>
    </Grid>
  )
}

TableContainer.propTypes = {
  tableHeaderRef: object,
  tableContainerIdentifier: string.isRequired,
  children: node.isRequired,
  actions: node,
  useExpandCell: bool,
  useAltBackground: bool,
  onResize: func,
  onScroll: func,
  className: string,
  checkByScrollWidth: bool,
}